exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".style-bullets-size-26rDg{margin-right:20px}.style-bullets-size-label-1FkjD{font-size:12px;margin-bottom:5px}.style-bullets-size-input-container-hR7vY{display:flex;align-items:center}.style-bullets-size-26rDg .style-input-suffix-text-1iEkc{font-size:12px;padding-left:6px}", ""]);

// Exports
exports.locals = {
	"bullets-size": "style-bullets-size-26rDg",
	"bullets-size-label": "style-bullets-size-label-1FkjD",
	"bullets-size-input-container": "style-bullets-size-input-container-hR7vY",
	"input-suffix-text": "style-input-suffix-text-1iEkc"
};